import { PinPosition } from "./PinPosition";
import { IFreigabe } from "./IFreigabe";
import { IGebaeudePos } from "./IGebaeudePos";

class PositionFactor {
    public x: number;
    public y: number;
}

const SPACE: number = 5;
const POSITIONS: PositionFactor[] = [
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 1 },
    { x: -1, y: 1 },
    { x: -1, y: 0 },
    { x: -1, y: -1 },
    { x: 0, y: -1 },
    { x: 1, y: -1 },
    { x: 2, y: 0 },
    { x: 2, y: 2 },
    { x: 0, y: 2 },
    { x: -2, y: 2 },
    { x: -2, y: 0 },
    { x: -2, y: -2 },
    { x: 0, y: -2 },
    { x: 2, y: -2 }
];

const GENERAL_POSITIONS: PositionFactor[] = [
    { x: 1, y: 0 },
    { x: 2, y: 0 },
    { x: 3, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 1 },
    { x: 2, y: 1 },
    { x: 3, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 2 },
    { x: 2, y: 2 },
    { x: 3, y: 2 },
    { x: 0, y: 3 },
    { x: 1, y: 3 },
    { x: 2, y: 3 },
    { x: 3, y: 3 }
];

export class OverlapCalculator {

    constructor(private items: IFreigabe[], private imgWidth: number, private imgHeight: number, private imgNaturalWidth: number, private imgNaturalHeight: number) {
    }

    //calcPosition(percentX: number, percentY: number, widthInRem: number, heightInRem: number): PinPosition {
    calcPosition(percentX: number, percentY: number, widthInRem: number, heightInRem: number): PinPosition {
        let isGeneralPin = false;
        if (percentX == 0 && percentY == 0) {
            // this is a general pin
            isGeneralPin = true;
            let generalPin = this.calcGeneralProcentages();
            percentX = generalPin.x;
            percentY = generalPin.y;
        }

        let itemsForThisLocation = this.items.filter(i => i.x == percentX && i.y == percentY);

        let result = new PinPosition();
        result.x = (this.imgWidth * percentX) / 100.0;
        result.y = (this.imgHeight * percentY) / 100.0;

        // calc centered position
        result.cx = widthInRem * parseFloat(getComputedStyle(document.documentElement).fontSize);
        result.cy = heightInRem * parseFloat(getComputedStyle(document.documentElement).fontSize);

        // divisor == 2 -> pin is centered in its area
        // divisor == 1 -> pin is at the leftmost position in its area. This should happen when there are more than 1 pins for its area.
        let divisorX = 2;
        if (itemsForThisLocation && itemsForThisLocation.length > 1 && itemsForThisLocation.length < 5) {
            divisorX = 1;
        }

        let halfDimensionX = result.cx / divisorX;
        let halfDimensionY = result.cy / 2;


        result.x -= halfDimensionX;
        if (result.x < 0) {
            result.x = 0;
        }
        if (result.right > this.imgWidth) {
            result.x = this.imgWidth - result.cx;
        }

        result.y -= halfDimensionY;
        if (result.y < 0) {
            result.y = 0;
        }
        if (result.bottom > this.imgHeight) {
            result.y = this.imgHeight - result.cy;
        }

        // position already used?
        if (this.isPositionUsed(result)) {
            // save original position
            const orgX = result.x;
            const orgY = result.y;

            let usedPositions = isGeneralPin ? GENERAL_POSITIONS : POSITIONS;
             
            for (let factor of usedPositions) {
                result.x = orgX + factor.x * (result.cx + SPACE);
                result.y = orgY + factor.y * (result.cy + SPACE);

                if (this.isInsideImage(result) && !this.isPositionUsed(result)) {
                    return result;
                }
            }
        }

        return result;
    }

    isInsideImage(pos: PinPosition): boolean {
        if (pos.x >= 0 && pos.right < this.imgWidth && pos.y >= 0 && pos.bottom < this.imgWidth) {
            return true;
        }
        return false;
    }

    isPositionUsed(pos: PinPosition): boolean {
        for (let item of this.items) {
            if (item.pin && item.pin.pos) {
                if (item.pin.pos.isInside(pos)) {
                    return true;
                }
            }
        }
        return false;
    }

    public calcPercentage = (x: number, y: number): IGebaeudePos => {
        let result: IGebaeudePos = {X:0,Y:0};

        result.X = (x * 100.0) / this.imgWidth;
        result.Y = (y * 100.0) / this.imgHeight;

        return result;
    }

    private calcGeneralProcentages = (): PositionFactor => {
        let generalPosition: PositionFactor = new PositionFactor();

        generalPosition.x = ((this.imgNaturalWidth - 250) * 100.0) / this.imgNaturalWidth;
        generalPosition.y = 9000.0 / this.imgNaturalHeight;

        return generalPosition;
    }
}